/* eslint complexity: ["error", 90] -- need to increase complexity */
/* eslint-disable max-len -- need */
export const validateTransferPoints = (transferPoints, data) => {
  let partner;
  const tierCode = data?.formSubmissionPayload?.TierCode;
  const ftoEnrollFlag = data?.formSubmissionPayload?.ftoEnrollFlag;

  if (tierCode === 'Y00') {
    partner = data?.formSubmissionPayload?.partnerAirlineY;
  } else {
    partner = data?.formSubmissionPayload?.partnerAirline || data?.formSubmissionPayload?.partnerHotel || data?.formSubmissionPayload?.partnerOther;
  }

  /*
  const getErrorMsgValue = () => {
    let errorMsgValue = 1000;
    if (
      (tierCode === 'M00' || (tierCode !== 'M00' && ftoEnrollFlag === 'yes'))
      && partner !== 'Yahoo'
      && partner !== 'Rakuten'
      && partner !== 'Marriott Bonvoy'
      && partner !== 'Hilton Hotel'
      && partner !== 'ANA'
      && partner !== 'Japan Airlines'
    ) {
      // partnerName14AirlinesChecked
      errorMsgValue = 1250;
    } else if (
      (tierCode === 'M00' || (tierCode !== 'M00' && ftoEnrollFlag === 'yes')) && partner === 'Japan Airlines'
    ) {
      // M00JALChecked
      errorMsgValue = 2500;
    } else if (tierCode !== 'M00' && ftoEnrollFlag !== 'yes' && partner === 'Japan Airlines') {
      // R00JALChecked
      errorMsgValue = 3000;
    }
    return errorMsgValue;
  };
  */

  if (partner && tierCode && transferPoints !== '') {
    if (tierCode === 'R00' || tierCode === 'R01' || tierCode === 'M00') {
      if (tierCode === 'M00' || (tierCode !== 'M00' && ftoEnrollFlag === 'yes') || (partner === 'ALL Accor')) {
        // FOR M00 OR FTO selected for R00/R01
        // if transferPoints are less or not divisible by transferRates for that partner --> throw error message
        let tierCodeKey = `${tierCode}`;
        if (tierCode !== 'M00') {
          tierCodeKey = ftoEnrollFlag === 'yes' ? `${tierCode}FTO` : `${tierCode}nonFTO`;
        }
        const transferRate = data?.formContainer?.staticMetadata?.transferRatesAndLabels?.transferRates?.[tierCodeKey]?.[partner];
        if (transferPoints >= 0 && transferRate) {
          if (transferPoints < transferRate) return `${transferRate}ポイント以上、${transferRate}ポイント単位でご入力ください。`;
          if (transferPoints % transferRate !== 0) return `${transferRate}ポイント単位でご入力ください。`;
        }
      }
      /* Removed validation as per the coms
      if (
        ftoEnrollFlag !== 'yes'
        && partner === 'Japan Airlines'
        && transferPoints > 300000
      ) {
        // transferPointsCustomRule6
        return '「JALマイレージバンク」への移行は1年間（月～12月）で150,000マイルまでとなります。（2,000ポイント=1,000マイルの換算です）';
      }
      */
      if (
        (partner === 'Yahoo' || partner === 'Rakuten')
        && transferPoints > 0
      ) {
        // transferPointsCustomRule1
        return 'ポイント移行の同時申し込みは承れません。';
      }
      if (
        ftoEnrollFlag !== 'yes'
        && partner === 'ANA'
        && transferPoints > 160000
      ) {
        // transferPointsCustomRule5
        return '「ANAマイレージクラブ」への移行は1年間（1月～12月）で40,000マイルまでとなります。（2,000ポイント=1,000マイルの換算です）';
      }
      /*  Removed validation as per the coms
      if (
        ftoEnrollFlag === 'yes'
        && partner === 'Japan Airlines'
        && transferPoints > 150000
      ) {
        // transferPointsCustomRule10
        return '「JALマイレージバンク」への移行は1年間（1月～12月）で150,000マイルまでとなります。';
      }
      */
      if (
        (tierCode === 'M00'
          || (tierCode !== 'M00' && ftoEnrollFlag === 'yes'))
        && partner !== 'ANA'
        && transferPoints > 998750
      ) {
        // transferPointsUpperLimitNonANARule
        return '一度に移行できる最大ポイント数は998,750ポイントまでです。';
      }
      if (
        tierCode !== 'M00'
        && ftoEnrollFlag !== 'yes'
        && partner === 'ANA'
        && transferPoints > 80000
      ) {
        // transferPointsUpperLimitR00R01ANARule
        return '移行できる最大ポイント数は80,000ポイントまでです。';
      }
      if (
        (tierCode === 'M00'
          || (tierCode !== 'M00' && ftoEnrollFlag === 'yes'))
        && partner === 'ANA'
        && transferPoints > 40000
      ) {
        // transferPointsUpperLimitM00ANARule
        return '移行できる最大ポイント数は40,000ポイントまでです。';
      }
      if (
        tierCode !== 'M00'
        && ftoEnrollFlag !== 'yes'
        && partner === 'Japan Airlines'
        && (transferPoints % 3000 !== 0)
      ) {
        // ftoCustomruleJALR00R01NotChecked
        return '3000ポイント単位でご入力ください(2,500ポイント単位での移行を希望の場合はメンバーシップリワードプラスへの登録をしてください)';
      }
      if (
        tierCode !== 'M00'
        && ftoEnrollFlag !== 'yes'
        && partner !== 'Japan Airlines'
        && partner !== 'ALL Accor'
        && (transferPoints % 2000 !== 0)
      ) {
        // ftoCustomruleR00R01NotChecked
        return '2000ポイント単位でご入力ください(1,000ポイント単位/1,250ポイント単位での移行を希望の場合はメンバーシップリワードプラスへの登録をしてください)';
      }
      if (
        tierCode !== 'M00'
        && ftoEnrollFlag !== 'yes'
        && partner !== 'ALL Accor'
        && transferPoints < 2000
        && transferPoints > 0
      ) {
        // ftoCustomruleR00R01NotCheckedLessThan2000
        return '2000ポイント以上、2000ポイント単位でご入力ください。1000ポイント単位でご希望の場合はメンバーシップ・リワード・プラスにご加入ください。';
      }
    } else if (tierCode === 'Y00') {
      /* Logic copied from old platform (mrtjedi_ja_JP)
      if (transferPoints > 0 && transferPoints % 1000 === 0) {
        // transferPointsCustomRuleFinal -->
        return '1,000ポイント以上、1,000ポイント単位でご入力ください。';
      }
      */
      if (transferPoints < 1000 || transferPoints % 1000 !== 0) {
        // transferPointsCustomRuleFinal -->
        return '1,000ポイント以上、1,000ポイント単位でご入力ください。';
      }
      if (partner === 'ANA' && transferPoints > 40000) {
        // transferPointsUpperLimitY00ANARule
        return '移行できる最大ポイント数は40,000ポイントまでです。';
      }
    }

    /* old logic commented out --> for M00 or FTO selected for R00/R01
      if (
        (tierCode === 'M00')
        || (tierCode !== 'M00' && ftoEnrollFlag === 'yes' && (transferPoints === 0 || transferPoints >= 1000))
        // || (tierCode !== 'M00' && ftoEnrollFlag !== 'yes') -->  invalid case --> won't let the remaining validation to trigger
        || (partner === 'Yahoo' || partner === 'Rakuten')
      ) {
        // ftoCustomrule
        const errorMsgValue = getErrorMsgValue();
        if (transferPoints < errorMsgValue) {
          return `${errorMsgValue}ポイント以上、${errorMsgValue}ポイント単位でご入力ください。`;
        }
      } else if (
        ((tierCode === 'M00' || (tierCode !== 'M00' && ftoEnrollFlag === 'yes'))
            && partner !== 'Yahoo'
            && partner !== 'Rakuten'
            && (
              (partner !== 'ANA' && partner !== 'Japan Airlines' && partner !== 'Marriott Bonvoy' && partner !== 'Hilton Hotel' && transferPoints % 1250 === 0)
                 || (
                   (partner === 'ANA' || partner === 'Marriott Bonvoy' || partner === 'Hilton Hotel')
                      && transferPoints % 1000 === 0
                 )
                 || (partner === 'Japan Airlines' && transferPoints % 2500 === 0)
            )
        )

        // || (tierCode !== 'M00' && ftoEnrollFlag !== 'yes') -> invalid case --> won't let the remaining validations to trigger
        || (partner === 'Yahoo' || partner === 'Rakuten')
      ) {
        // ftoCustomrule1
        const errorMsgValue = getErrorMsgValue();
        if (transferPoints < errorMsgValue) {
          return `${errorMsgValue}ポイント単位でご入力ください。`;
        }
      } */
  }

  return null;
};
/* eslint-enable max-len -- need */
